<template>
<div v-loading="loading" class="full">
  <w-flow-map-title :rscPerfData="rscPerfData" :objtypeId="selectedNode.obj.objtypeId" />
  <div class="default-layout type01-layout">
    <div class="col row-half">
      <w-flow-map-user-process :rsc-perf-data="rscPerfData" :objtype-id="selectedNode.obj.objtypeId" :show-flow-field-label="false"/>
      <w-flow-map-system-tab :systemTabData="rscPerfData"></w-flow-map-system-tab>
    </div>
    <div class="col row-full">
      <div class="flowmap-box">
        <!-- arrow -->
        <w-flow-map-flow-field
        :perfRecords="rscPerfData"
        perfKey=""
        :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
        </w-flow-map-flow-field>
        <!-- arrow -->

        <!-- arrow -->
        <w-flow-map-flow-field
        :perfRecords="rscPerfData"
        perfKey=""
        :arrow-settings="{ top: '550px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
        </w-flow-map-flow-field>
        <!-- arrow -->
        <div class="flowmap-header thema-dark">
          Broker
        </div>
        <div class="flowmap-content">
          <div class="flowmap-content-header">
            <ul class="flowmap-list">
              <li>
                <div class="txt-area">
                  <span class="txt">· Broker 수</span>
                  <span class="num">{{ brokers.length }}</span>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="!checkBrokers(rscPerfData.CU_BROKERS)">
            <ul class="flowmap-list is-border" v-for="item in brokers" :key="item.rscKey">
              <li><i class="fas fa-bullseye"></i> <strong>{{item.rscKey}}</strong></li>
              <w-flow-map-item-label :perfRecords="item" perfKey="CU_PROC/DBCU_BROKER_CONNECT_COUNT" label="연결 횟수"></w-flow-map-item-label>
              <w-flow-map-item-label :perfRecords="item" perfKey="CU_PROC/DBCU_BROKER_JOB_QUEUE_COUNT" label="Job Queue 수"></w-flow-map-item-label>
            </ul>
          </div>
          <ul class="flowmap-list is-border">
            <li class="row-end">
              <div class="flowmap-box">
                <div class="flowmap-header thema-dark">
                  CAS
                </div>
                <div class="flowmap-content">
                  <ul class="flowmap-list is-border">
                    <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_PROC/DBCU_TOTAL_CAS_COUNT" label="전체 CAS 수"></w-flow-map-item-label>
                    <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_PROC/DBCU_BUSY_CAS_COUNT" label="Busy CAS 수"></w-flow-map-item-label>
                    <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_PROC/DBCU_CLIENT_WAIT_CAS_COUNT" label="Client Wait CAS 수"></w-flow-map-item-label>
                    <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_PROC/DBCU_CLOSE_WAIT_CAS_COUNT" label="Close Wait CAS 수"></w-flow-map-item-label>
                    <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_PROC/DBCU_IDLE_CAS_COUNT" label="Idle Wait CAS 수"></w-flow-map-item-label>
                  </ul>
                </div>
              </div>
            </li>
          </ul>


        </div>
      </div>
    </div>
    <div class="col row-full">
      <div class="flowmap-box">
        <!-- arrow -->
        <w-flow-map-flow-field
        :perfRecords="rscPerfData"
        perfKey=""
        :arrow-settings="{ top: '600px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
        </w-flow-map-flow-field>
        <!-- arrow -->

        <!-- arrow -->
        <w-flow-map-flow-field
        :perfRecords="rscPerfData"
        perfKey=""
        :arrow-settings="{ top: '100px', arrowDirection: 'arrow-right', arrowSize: 'small'}">
        </w-flow-map-flow-field>
        <!-- arrow -->
        <!-- arrow -->
        <div class="flowmap-header thema-dark">
          DB Server
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Buffer</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_MEMSTAT/DBCU_DATA_BUF_SIZE" label="Data Buffer 크기"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_MEMSTAT/DBCU_SORT_BUF_SIZE" label="Sort Buffer 크기"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_MEMSTAT/DBCU_LOG_BUF_SIZE" label="Log Buffer 크기"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO" :isValue="false" label="Buffer Cache 적중률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO"></w-flow-map-progressbar>
            </w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Page Buffer</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_DATA_FETCHE_PAGE_COUNT" label="Data Page Fetches"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_DATA_DIRTY_PAGE_COUNT" label="Data Page Dirtes"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_DATA_IOREAD_PAGE_COUNT" label="Data Page I/O Read"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_DATA_IOWRITE_PAGE_COUNT" label="Data Page I/O Write"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Transaction</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_TRAN_COMMIT_COUNT" label="Commits"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_SYSSTAT/DBCU_TRAN_ROLLBACK_COUNT" label="Rollbacks"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Network</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_NETWORK/DBCU_NET_REQUEST_COUNT" label="Network Request"></w-flow-map-item-label>
          </ul>
        </div>
      </div>
    </div>

    <div class="col row-full">
      <div class="flowmap-box">
        <!-- arrow -->
        <w-flow-map-flow-field
        :perfRecords="rscPerfData"
        perfKey=""
        :arrow-settings="{ top: '200px', arrowDirection: 'arrow-left', arrowSize: 'small'}">
        </w-flow-map-flow-field>
        <!-- arrow -->
        <div class="flowmap-header thema-dark">
          Disk Storage
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list is-border">
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USERATE" label="Volume 사용률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USERATE"></w-flow-map-progressbar>
            </w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_USEDSIZE" label="사용량"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TABLESPACE/DB_TABLESPACE_AVSIZE" label="가용량"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Generic</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="GENERIC/CU_TABLESPACE/DBCU_VOL_TOTSIZE_BY_PURPOSE" label="Volume 사용률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="GENERIC/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE"></w-flow-map-progressbar>
            </w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="GENERIC/CU_TABLESPACE/DBCU_VOL_USEDSIZE_BY_PURPOSE" label="사용량"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Data</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DATA/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE" :isValue="false" label="Volume 사용률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="DATA/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE"></w-flow-map-progressbar>
            </w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="DATA/CU_TABLESPACE/DBCU_VOL_USEDSIZE_BY_PURPOSE" label="사용량"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Index</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="INDEX/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE" :isValue="false" label="Volume 사용률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="INDEX/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE"></w-flow-map-progressbar>
            </w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="INDEX/CU_TABLESPACE/DBCU_VOL_USEDSIZE_BY_PURPOSE" label="사용량"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Temp</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TEMP/CU_TABLESPACE/DBCU_VOL_TOTSIZE_BY_PURPOSE" label="Volume 사용률">
              <w-flow-map-progressbar slot="progressbar" :perfRecords="rscPerfData" perfKey="TEMP/CU_TABLESPACE/DBCU_VOL_USERATE_BY_PURPOSE"></w-flow-map-progressbar>
            </w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="TEMP/CU_TABLESPACE/DBCU_VOL_USEDSIZE_BY_PURPOSE" label="사용량"></w-flow-map-item-label>
          </ul>

          <ul class="flowmap-list is-border">
            <li><i class="fas fa-bullseye"></i> <strong>Log</strong></li>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_TABLESPACE/DBCU_ACTIVE_LOG_SIZE" label="Active 로그 크기"></w-flow-map-item-label>
            <w-flow-map-item-label :perfRecords="rscPerfData" perfKey="CU_TABLESPACE/DBCU_ARCHIVE_LOG_SIZE" label="Archive 로그 크기"></w-flow-map-item-label>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { isNil, forEach, find, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import FlowMapAPI from '@/api/performance/database/flow-map';
import WFlowMapSystemTab from '@/views/performance/node/database-flow-map/components/FlowMapSystemTab';
import WFlowMapTitle from '@/views/performance/node/database-flow-map/components/FlowMapTitle';
import WFlowMapUserProcess from '@/views/performance/node/database-flow-map/components/FlowMapUserProcess';
import WRscPerfEventTextLabel from '@/components/textLabel/RscPerfEventTextLabel';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import WFlowMapTableItemCount from '@/views/performance/node/database-flow-map/components/FlowMapTableItemCount';
import WFlowMapItemLabel from './components/FlowMapItemLabel';
import WFlowMapFlowField from './components/FlowMapFlowField';
import WFlowMapProgressbar from './components/FlowMapProgressbar';

export default {
  name: 'WCubridFlowMap',
  components: {
    WFlowMapSystemTab,
    WRscPerfEventProgressBar,
    WRscPerfEventTextLabel,
    WFlowMapUserProcess,
    WFlowMapTitle,
    WFlowMapTableItemCount,
    WFlowMapItemLabel,
    WFlowMapFlowField,
    WFlowMapProgressbar,
  },
  props: {
    active: Boolean,
    selectedNode: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      rscPerfData: {},
      brokers: [],
    };
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        if (isNil(this.active)) {
          return;
        }
        // handler (to, from)
        // 선택된 DB가 변경될 때 수행해야할 로직 작성.
        this.loadData();
      },
    },
    /**
     * [Flow 맵] 탭 활성화 시 재로드
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.loadData();
      }
    },
  },
  methods: {
    find,
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        objtypeId: this.selectedNode.obj.objtypeId,
      };
      this.loading = true;
      FlowMapAPI.getRscPerfAndEventOfDatabase(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.rscPerfData = response.data.data[0];
          const brokers = this.rscPerfData.CU_BROKERS;
          forEach(brokers, (item) => {
            const hasBroker = find(this.brokers, { rscKey: item.rscKey });
            if (isEmpty(hasBroker)) {
              const broker = {
                rscKey: item.rscKey,
              };
              broker[item.rscIDKey] = item.value;
              this.brokers.push(broker);
            } else {
              hasBroker[item.rscIDKey] = item.value;
            }
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    checkBrokers(data) {
      return isNil(data);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/CubridFlowMap.vue